import { render } from "./EDMap.vue?vue&type=template&id=1ddf2aff"
import script from "./EDMap.vue?vue&type=script&lang=js"
export * from "./EDMap.vue?vue&type=script&lang=js"

import exportComponent from "E:\\c2stem\\c2stem-classroom\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__